import {WHSSubsAPI_BASE_URL, PROMOTION_API_BASE_URL, API_BASE_URL, JAZZ_WEBDOC_DETAILS_API_BASE_URL } from "../config/apiConfig";

const toUfoneMsisdn = (phone) => {
  const d = String(phone || "").replace(/\D/g, "");
  if (d.startsWith("92") && d.length === 12) return `0${d.slice(2)}`;
  if (d.startsWith("0") && d.length === 11) return d;
  if (d.length === 10) return `0${d}`;
  return d;
};

const toPromotionMsisdn = (phone) => {
  const d = String(phone || "").replace(/\D/g, "");
  if (d.startsWith("92") && d.length === 12) return d;
  if (d.startsWith("0") && d.length === 11) return d;
  if (d.length === 10) return `0${d}`;
  return d;
};

const toJazzMsisdn = (phone) => {
  const d = String(phone || "").replace(/\D/g, "");
  if (d.startsWith("92") && d.length === 12) return `0${d.slice(2)}`;
  if (d.startsWith("0") && d.length === 11) return d;
  if (d.length === 10) return `0${d}`;
  return d;
};

const toTelenorMsisdn = (phone) => {
  const d = String(phone || "").replace(/\D/g, "");
  if (d.startsWith("92") && d.length === 12) return `0${d.slice(2)}`;
  if (d.startsWith("0") && d.length === 11) return d;
  if (d.length === 10) return `0${d}`;
  return d;
};

export const unsubscribePromotionSubscription = async (phone, apiService) => {
  const msisdn = toPromotionMsisdn(phone);
  const url = `${PROMOTION_API_BASE_URL}/un-subscribe`;

  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Basic V2ViRG9jOldlYkRvY0AxMjM=",
    },
    body: JSON.stringify({ api_service: apiService, msisdn }),
  });

  const text = await res.text();
  let json = null;
  if (text) {
    try {
      json = JSON.parse(text);
    } catch (error) {
      console.warn("[Zong Promotion] unsubscribe response was not JSON", text);
    }
  }

  if (!res.ok) {
    throw new Error(json?.statusMessage?.[0] || `Unsubscribe failed with status ${res.status}`);
  }

  return json;
};

export const unsubscribeUfoneSubscription = async (phone) => {
  const msisdn = toUfoneMsisdn(phone);
  const url = `${API_BASE_URL}/ufone/unSubscribe?dbname=MIS&cellno=${msisdn}&unSubMode=WEB`;

  const res = await fetch(url, {
    method: "GET",
    headers: { Accept: "application/json" },
  });

  const text = await res.text();
  let json = null;
  if (text) {
    try {
      json = JSON.parse(text);
    } catch (error) {
      console.warn("[Ufone] unsubscribe response was not JSON", text);
    }
  }

  if (!res.ok) {
    throw new Error(json?.message || "Unable to process unsubscribe request.");
  }

  return json;
};

/**
 * Jazz unsubscribe
 * productCode  → e.g. "WEBDOCCROPINSDAILY2" (svc.productCode from subDetails)
 * serviceName  → display label, e.g. "Webdoc Crop Insurance" (svc.name — NOT raw serviceName like "crop_insurance")
 * channel      → e.g. "Digital" / "SMS" (svc.channel)
 */
export const unsubscribeJazzSubscription = async (phone, productCode, serviceName, channel = "Digital") => {
  const msisdn = toJazzMsisdn(phone);
  const url = `${JAZZ_WEBDOC_DETAILS_API_BASE_URL}/unSubscribe?msisdn=${msisdn}&productCode=${encodeURIComponent(productCode)}&serviceName=${encodeURIComponent(serviceName)}&channel=${encodeURIComponent(channel)}`;

  const res = await fetch(url, {
    method: "GET",
    headers: { Accept: "application/json" },
  });

  const text = await res.text();
  let json = null;
  if (text) {
    try {
      json = JSON.parse(text);
    } catch (error) {
      console.warn("[Jazz] unsubscribe response was not JSON", text);
    }
  }

  if (!res.ok || !json?.success) {
    throw new Error(json?.message || "Unable to process Jazz unsubscribe request.");
  }

  return json;
};

/**
 * Telenor unsubscribe
 * dbname   → the product/db identifier tied to this service (svc.dbname,
 *            set from the "product" field returned by subDetails, e.g. "khushal_muhafiz")
 * unSubMode is kept static ("SMS") for now, as requested.
 *
 * Response shape when there's nothing to unsubscribe:
 *   { "success": false, "message": "No Policy Found" }
 * That's an expected outcome (not necessarily an error) — the caller
 * decides how to present it, so we don't throw purely on success:false.
 */
export const unsubscribeTelenorSubscription = async (phone, dbname) => {
  const msisdn = toTelenorMsisdn(phone);
  const unSubMode = "SMS"; // static for now
  const url = `${API_BASE_URL}/telenor/unSubscribe?dbname=${encodeURIComponent(dbname || "")}&cellno=${msisdn}&unSubMode=${unSubMode}`;

  const res = await fetch(url, {
    method: "GET",
    headers: { Accept: "application/json" },
  });

  const text = await res.text();
  let json = null;
  if (text) {
    try {
      json = JSON.parse(text);
    } catch (error) {
      console.warn("[Telenor] unsubscribe response was not JSON", text);
    }
  }

  if (!res.ok) {
    throw new Error(json?.message || "Unable to process unsubscribe request.");
  }

  return json;
};


/**
 * Easypaisa / WHS unsubscribe
 * id → the record's unique id (from the WHS record object, e.g. record.id)
 */
export const unsubscribeWHSSubscription = async (id) => {
  const url = `${WHSSubsAPI_BASE_URL}UnsubscribeWHSSubscriptions?id=${id}`;

  const res = await fetch(url, {
    method: "POST",
    headers: { Accept: "*/*" },
    body: "",
  });

  const text = await res.text();
  let json = null;
  if (text) {
    try {
      json = JSON.parse(text);
    } catch (error) {
      console.warn("[Easypaisa/WHS] unsubscribe response was not JSON", text);
    }
  }

  if (!res.ok) {
    throw new Error(json?.Message || json?.message || `Unsubscribe failed with status ${res.status}`);
  }

  return json;
};